/** @format */

import { config } from "@/Helper/config";
import axios from "axios";

const getAllUtilityData = () => {
  return axios.get(`${config.strapiAPi}/api/utility?populate=*`);
};

const getAllFAQ = () => {
  return axios.get(`${config.strapiAPi}/api/faqs`);
};
const getFAQByCategory = ({ page }) => {
  return axios.get(`${config.strapiAPi}/api/getfaq/${page}`);
};

const getRecentBlog = (
  currentPage = null,
  category = null,
  searchTerm = null
) => {
  const pagination =
    currentPage && currentPage >= 1
      ? `&pagination[page]=${currentPage}&pagination[pageSize]=12`
      : "";

  const categoryFilter = category ? `&filters[category][$eq]=${category}` : "";

  // Add a filter for the title if searchTerm is provided
  const searchFilter = searchTerm
    ? `&filters[title][$containsi]=${searchTerm}`
    : "";

  return axios.get(
    `${config.strapiAPi}/api/blogs?populate=image&sort=publishedAt:desc${pagination}${categoryFilter}${searchFilter}`

  );
};


const getRecentBlogWithkeySearch = ({ keyword = "-" }) => {
  return axios.get(`${config.strapiAPi}/api/bloggers/${keyword ?? "-"}`);
};

const getBlogDetailsById = ({ id }) => {
  console.log('api --------------------------------------',`${config.strapiAPi}/api/blogger/${id}`)
  return axios.get(`${config.strapiAPi}/api/blogger/${id}`, {
    rejectUnauthorized: false,
    strictSSL: false,
  });
};


const postContactUsDetails = ({ data }) => {
  return axios.post(`${config.strapiAPi}/api/contact-uses`, { data });
};

const postcareersDetails = async (formData) => {
  return axios.post(`${config.strapiAPi}/api/job-applications`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const sendThankyouMail = ({ data }) => {
  return axios.post(`${config.strapiAPi}/api/email`, data);
};

const sendThankyouMailCareers = ({ data }) => {
  return axios.post(`${config.strapiAPi}/api/careers`, data);
};

export const apiService = {
  getAllUtilityData,
  getAllFAQ,
  getRecentBlog,
  getBlogDetailsById,
  postContactUsDetails,
  postcareersDetails,
  sendThankyouMail,
  sendThankyouMailCareers,
  getFAQByCategory,
  getRecentBlogWithkeySearch,
};
